export type WidthOption =
  | 'full'
  | '11/12'
  | '10/12'
  | '3/4'
  | '2/3'
  | '7/12'
  | '1/2'
  | '5/12'
  | '1/3'
  | '1/4'
  | '2/12'
  | '1/12'

export const gridWidth = (width: WidthOption): string => {
  const spanClass =
    width === '11/12'
      ? 'layout-grid__cell--w-11'
      : width === '10/12'
      ? 'layout-grid__cell--w-10'
      : width === '3/4'
      ? 'layout-grid__cell--w-9'
      : width === '2/3'
      ? 'layout-grid__cell--w-8'
      : width === '7/12'
      ? 'layout-grid__cell--w-7'
      : width === '1/2'
      ? 'layout-grid__cell--half'
      : width === '5/12'
      ? 'layout-grid__cell--w-5'
      : width === '1/3'
      ? 'layout-grid__cell--w-4'
      : width === '1/4'
      ? 'layout-grid__cell--w-3'
      : width === '2/12'
      ? 'layout-grid__cell--w-2'
      : width === '1/12'
      ? 'layout-grid__cell--w-1'
      : null

  return spanClass ? `layout-grid__cell ${spanClass}` : 'layout-grid__cell'
}

/** @deprecated Use gridWidth — spans are container-based, not viewport-based. */
export const gridWidthXl = gridWidth

/** @deprecated Use gridWidth — spans are container-based, not viewport-based. */
export const gridWidthLg = gridWidth

/** @deprecated Use gridWidth — spans are container-based, not viewport-based. */
export const gridWidthMd = gridWidth
